import autoInput from './photos/auto_priemka.jpg';
// import input from './photos/input.jpg';
// import input from './photos/input.jpg';
import cleaning from './photos/cleaning.jpg';
// import drying from './photos/drying.jpg';
import storage from './photos/storage.jpg';
// import output from './photos/output.jpg';
import trainOutput from  './photos/train_otgruzka.jpg';
import truckOutput from  './photos/auto_otgruzka.jpg';
import bonfanti190 from './photos/BonfantiXL190CE.jpg';
import bonfanti265 from './photos/BonfantiХL265CE.jpg';
import buhler203 from './photos/BuhlerSMA-203.jpg';
import buhler204 from './photos/BuhlerTAS204-A4.jpg';
import cimbria from './photos/CimbriaAG40.jpg';
// import grainhandler from './photos/GrainHandler.jpg';
// import gsi7000 from './photos/GSI7000.jpg';
import mathews from './photos/MathewsCompany1195.jpg';
import mc3180 from './photos/MC-3180.jpg';
import spo125 from './photos/SPO-125.jpg';
import strahl from './photos/Strahl18000FR14.jpg';
// import tas154 from './photos/TAS154A-4.jpg';
// import tas206 from './photos/TAS-206.jpg';
import tornumhr8 from './photos/TORNUMHR8-27-3.jpg';
import tornumtk12 from './photos/TORNUMTK12-28-4.jpg';
import tornumtk8 from './photos/TORNUMTK-8-28-4.jpg';
import zso150 from './photos/ZSO-150.jpg';
import nophoto from './photos/no_photo.jpg';
import hopper from './photos/hopper.jpg'

const equipSettings = {
    "inputEquip": [
        {
            "name": "Завальна яма 50т",
            "price": "105.000",
            "picture": autoInput,
            "quantity": 0,
            "definition": "",
            "capacity": "50"
        },
        {
            "name": "Завальна яма 100т",
            "price": "320.000",
            "picture": autoInput,
            "quantity": 0,
            "definition": "",
            "capacity": "100"
        },
        {
            "name": "Завальна яма 150т",
            "price": "355.000",
            "picture": autoInput,
            "quantity": 0,
            "definition": "",
            "capacity": "150"
        },
        {
            "name": "Завальна яма 175т",
            "price": "380.000",
            "picture": autoInput,
            "quantity": 0,
            "definition": "",
            "capacity": "175"
        }
    ],
    "cleaningEquip": [
        {
            "name": "Buhler SMA-203",
            "price": "100.000",
            "picture": buhler203,
            "definition": "Благодаря совмещению двух этапов очистки в одной машине сепараторы SMA обеспечивают высокую производительность при минимальной площади размещения. Особенности конструкции машины включают доступ к ситам в передней части для упрощения процесса их замены и очистки.",
            "wheatpercents": {min:2,max:9},
            "wheateff": {min:110,max:75},
            "rapepercents": {min:2,max:9},
            "rapeeff": {min:60,max:45},
            "soypercents": {min:2,max:9},
            "soyeff": {min:100,max:75},
            "sunflowerpercents": {min:2,max:9},
            "sunflowereff": {min:55,max:30},
            "cornpercents": {min:2,max:9},
            "corneff": {min:80,max:55},
            "quantity": 0
        },
        {
            "name": "Buhler TAS 206",
            "price": "250.000",
            "picture": cleaning,
            "definition": "Сепараторы  TAS-206 предназначены для предварительной и основной очистки зерна.",
            "wheatpercents": {min:2,max:9},
            "wheateff": {min:170,max:130},
            "rapepercents": {min:2,max:9},
            "rapeeff": {min:140,max:70},
            "soypercents": {min:2,max:9},
            "soyeff": {min:150,max:110},
            "sunflowerpercents": {min:2,max:9},
            "sunflowereff": {min:90,max:60},
            "cornpercents": {min:2,max:9},
            "corneff": {min:150,max:150},
            "quantity": 0
        },
        {
            "name": "Buhler TAS 204-A4",
            "price": "320.000",
            "picture": buhler204,
            "definition": "",
            "wheatpercents": {min:2,max:9},
            "wheateff": {min:130,max:60},
            "rapepercents": {min:2,max:9},
            "rapeeff": {min:120,max:50},
            "soypercents": {min:2,max:9},
            "soyeff": {min:120,max:50},
            "sunflowerpercents": {min:2,max:9},
            "sunflowereff": {min:112,max:45},
            "cornpercents": {min:2,max:9},
            "corneff": {min:130,max:60},
            "quantity": 0
        },
        {
            "name": "СПО-175",
            "price": "10.000",
            "picture": spo125,
            "definition": "",
            "wheatpercents": {min:2,max:9},
            "wheateff": {min:175,max:135},
            "rapepercents": {min:2,max:9},
            "rapeeff": {min:100,max:80},
            "soypercents": {min:2,max:9},
            "soyeff": {min:165,max:125},
            "sunflowerpercents": {min:2,max:9},
            "sunflowereff": {min:85,max:65},
            "cornpercents": {min:2,max:9},
            "corneff": {min:165,max:125},
            "quantity": 0
        },
        // {
        //     "name": "БЦСМ",
        //     "price": "380.000",
        //     "picture": nophoto,
        //     "definition": "",
        //     "wheatpercents": {min:2,max:9},
        //     "wheateff": {min:50,max:30},
        //     "rapepercents": {min:2,max:9},
        //     "rapeeff": {min:40,max:20},
        //     "soypercents": {min:2,max:9},
        //     "soyeff": {min:50,max:30},
        //     "sunflowerpercents": {min:2,max:9},
        //     "sunflowereff": {min:25,max:15},
        //     "cornpercents": {min:2,max:9},
        //     "corneff": {min:50,max:30},
        //     "quantity": 0
        // },
        // {
        //     "name": "ЗСО-150",
        //     "price": "35.000",
        //     "picture": zso150,
        //     "definition": "Зерноочистительный сепаратор предназначен для очистки зерна сельскохозяйственных культур от крупных, мелких и легких примесей.",
        //     "wheatpercents": {min:2,max:9},
        //     "wheateff": {min:100,max:60},
        //     "rapepercents": {min:2,max:9},
        //     "rapeeff": {min:80,max:40},
        //     "soypercents": {min:2,max:9},
        //     "soyeff": {min:100,max:60},
        //     "sunflowerpercents": {min:2,max:9},
        //     "sunflowereff": {min:50,max:30},
        //     "cornpercents": {min:2,max:9},
        //     "corneff": {min:100,max:60},
        //     "quantity": 0
        // },
        {
            "name": "Buhler TAS 154A-4",
            "price": "90.000",
            "picture": nophoto,
            "definition": "Buhler 154A-4 оптимально подходят для применения на предприятиях учета и приемки зерна и прочих сыпучих материалов, в портовом хозяйстве, на мельницах, элеваторах и хранилищах, предприятиях обработки семенного материала, а также на солодовнях.",
            "wheatpercents": {min:2,max:9},
            "wheateff": {min:125,max:120},
            "rapepercents": {min:2,max:9},
            "rapeeff": {min:95,max:90},
            "soypercents": {min:2,max:9},
            "soyeff": {min:135,max:130},
            "sunflowerpercents": {min:2,max:9},
            "sunflowereff": {min:65,max:60},
            "cornpercents": {min:2,max:9},
            "corneff": {min:165,max:160},
            "quantity": 0
        }
    ],
    "dryingEquip": [
        {
            "name": "TORNUM HR 8-27-3",
            "price": "660.000",
            "picture": tornumhr8,
            "definition": "Зерновая сушилка TORNUM АВ модели HR разработана исключительно для проведения процесса сушки зерновых, зернобобовых, масличных культур. Особенность  данной сушилки является использование принципа  рециркуляции воздуха. В результате достигается снижение расхода энергии  на проведение сушки потока зерна.",
            "wheatpercents": {min:2,max:10},
            "wheateff": {min:54,max:33},
            "rapepercents": {min:2,max:10},
            "rapeeff": {min:30,max:17},
            "soypercents": {min:2,max:10},
            "soyeff": {min:29,max:17},
            "sunflowerpercents": {min:2,max:10},
            "sunflowereff": {min:21,max:13},
            "cornpercents": {min:2,max:19},
            "corneff": {min:42,max:17},
            "quantity": 0
        },
        {
            "name": "Strahl 18000 FR/14",
            "price": "1.000.000",
            "picture": strahl,
            "definition": "Зерносушилка энергосберегающая Strahl 18000 FR/14 оснащена системой рекуперации тепла, вентиляторами  с  глушителями шума, системой компьютерного управления.  Полностью утепленная  зерносушильная колона.",
            "wheatpercents": {min:2,max:10},
            "wheateff": {min:140,max:85},
            "rapepercents": {min:2,max:10},
            "rapeeff": {min:70,max:35},
            "soypercents": {min:2,max:10},
            "soyeff": {min:95,max:62},
            "sunflowerpercents": {min:2,max:10},
            "sunflowereff": {min:62,max:32},
            "cornpercents": {min:2,max:19},
            "corneff": {min:134,max:44},
            "quantity": 0
        },
        {
            "name": "Tornum TK 12-28-4",
            "price": "1.100.000",
            "picture": tornumtk12,
            "definition": "Сушилка для зерновых культур непрерывного действия шахтного типа модели TK 12-28-4 разработана исключительно для проведения процесса сушки таких культур как : пшеница, кукуруза, ячмень, рожь, овёс, рапс, горох, подсолнечник, соя и др. Также данная сушилка оснащена системой управления «Intelligient Dryer Control System» , которая позволяет управлять всеми процессами сушения в реальном времени при использовании и мониторинга всех параметров сушилки, системой очистки воздуха и системой обнаружения пожара.",
            "wheatpercents": {min:2,max:10},
            "wheateff": {min:140,max:50},
            "rapepercents": {min:2,max:10},
            "rapeeff": {min:140,max:60},
            "soypercents": {min:2,max:10},
            "soyeff": {min:90,max:10},
            "sunflowerpercents": {min:2,max:10},
            "sunflowereff": {min:90,max:40},
            "cornpercents": {min:2,max:19},
            "corneff": {min:140,max:30},
            "quantity": 0
        },
        {
            "name": "Mathews Company 3180",
            "price": "250.000",
            "picture": mathews,
          "definition": "Зерносушилка Mathews Company 3180 с многоступенчатыми зонами сушки, обеспечивает эффективность использования топлива и сохранение качества зерна",
            "wheatpercents": {min:2,max:10},
            "wheateff": {min:90,max:64},
            "rapepercents": {min:2,max:10},
            "rapeeff": {min:70,max:32},
            "soypercents": {min:2,max:10},
            "soyeff": {min:70,max:32},
            "sunflowerpercents": {min:2,max:10},
            "sunflowereff": {min:45,max:20},
            "cornpercents": {min:2,max:10},
            "corneff": {min:70,max:32},
            "quantity": 0
        },
        {
            "name": "Cimbria AG40",
            "price": "550.000",
            "picture": cimbria,
            "definition": "Зерновая сушка Кимбрия шахтного типа, с линейной газовой горелкой, открытого типа.",
            "wheatpercents": {min:2,max:10},
            "wheateff": {min:65,max:35},
            "rapepercents": {min:2,max:10},
            "rapeeff": {min:40,max:20},
            "soypercents": {min:2,max:10},
            "soyeff": {min:60,max:30},
            "sunflowerpercents": {min:2,max:10},
            "sunflowereff": {min:30,max:15},
            "cornpercents": {min:2,max:19},
            "corneff": {min:60,max:8},
            "quantity": 0
        },
        {
            "name": "Bonfanti XL190CE",
            "price": "700.000",
            "picture": bonfanti190,
            "definition": "Зерносушилка Бонфанти, шахтная сушилка, с функцией рекуперации тепла, закритого типа, паралельно расположенные горелки –для лучшей эффективности сушки зерна.",
            "wheatpercents": {min:2,max:10},
            "wheateff": {min:65,max:35},
            "rapepercents": {min:2,max:10},
            "rapeeff": {min:40,max:20},
            "soypercents": {min:2,max:10},
            "soyeff": {min:60,max:30},
            "sunflowerpercents": {min:2,max:10},
            "sunflowereff": {min:30,max:15},
            "cornpercents": {min:2,max:19},
            "corneff": {min:60,max:8},
            "quantity": 0
        },
        {
            "name": "Bonfanti  XL265SE",
            "price": "1.050.000",
            "picture": bonfanti265,
            "definition": "Зерносушилка Bonfanti ХL 265 CE предназначена для  бесперебойного сушения зерна пшеницы, ржи, ячменя, овса, кукурузы, риса, рапса и  других зерновых, бобовых культур.",
            "wheatpercents": {min:2,max:10},
            "wheateff": {min:50,max:35},
            "rapepercents": {min:2,max:10},
            "rapeeff": {min:40,max:20},
            "soypercents": {min:2,max:10},
            "soyeff": {min:30,max:16},
            "sunflowerpercents": {min:2,max:10},
            "sunflowereff": {min:30,max:12},
            "cornpercents": {min:2,max:19},
            "corneff": {min:45,max:24},
            "quantity": 0
        },
        {
            "name": "Mathews Company 1195",
            "price": "615.000",
            "picture": mathews,
            "definition": "Зерносушилка Mathews Company 1195 с многоступенчатыми зонами сушки, обеспечивает эффективность использования топлива и сохранение качества зерна",
            "wheatpercents": {min:2,max:10},
            "wheateff": {min:60,max:40},
            "rapepercents": {min:2,max:10},
            "rapeeff": {min:40,max:20},
            "soypercents": {min:2,max:10},
            "soyeff": {min:45,max:25},
            "sunflowerpercents": {min:2,max:10},
            "sunflowereff": {min:35,max:15},
            "cornpercents": {min:2,max:19},
            "corneff": {min:50,max:15},
            "quantity": 0
        },
        {
            "name": "Тornum TK 8-28-4",
            "price": "390.000",
            "picture": tornumtk8,
            "definition": "Довговічність зернових сушарок від компанії Grain Handler в тому, що ми використовуємо тільки високоякісні матеріали для виготовлення всіх деталей. Всі поверхні модуля зернової сушарки, включаючи повітряні вентилятори і основу зернової сушарки, покриті цинком завтовшки 350 грам на м². А де необхідно, застосовується нержавіюча сталь. Термін служби до 30 років, в залежності від інтенсивності експлуатації. Завдяки цьому наші зернові сушарки – одні з найбільш надійних.",
            "wheatpercents": {min:2,max:10},
            "wheateff": {min:110,max:80},
            "rapepercents": {min:2,max:10},
            "rapeeff": {min:75,max:50},
            "soypercents": {min:2,max:10},
            "soyeff": {min:110,max:70},
            "sunflowerpercents": {min:2,max:10},
            "sunflowereff": {min:70,max:45},
            "cornpercents": {min:2,max:19},
            "corneff": {min:120,max:45},
            "quantity": 0
        },
        // {
        //     "name": "GSI 7000",
        //     "price": "1.000.000",
        //     "picture": tornumtk8,
        //     "definition": "Компания GSI известна во всем мире благодаря высокому качеству своих инженерных разработок. Яркий пример тому — наша башенная сушилка, при проектировании которой мы использовали инновации, превзойти которые до сих пор не удалось никому в отрасли. В своих разработках мы использовали проверенные на практике принципы сушки, а также множество уникальных характеристик, позволивших превратить наши башенные сушилки в простую, надежную и топливоэкономичную систему сушки зерна.Каждая сушилка представляет собой конструкцию, скрепленную болтами (не сваркой), которая предусматривает широкое применение оцинкованной стали (без необходимости покраски) во всей сушилке. Кроме того, в стандартную комплектацию всех сушилок входит свальцованное внешнее листовое покрытие из нержавеющей стали. Эти особенности конструкции сушилки упрощают ее установку и улучшают ее внешний вид, а также обеспечивают более длительный срок службы установки. Конструкция нижней части бункера, используемого в сушилке, включая запатентованный компанией GSI барабан дозатора, обеспечивает простую и эффективную разгрузку зерна. Эта система разгрузки равномерно выгружает зерно из сушилки и предусматривает простую очистку сушилки.Органы управления на сенсорном экране осуществляют автоматизированное управление всеми функциями сушилки. Эта «интеллектуальная» система устраняет необходимость действовать наугад, мгновенно предоставляя оператору информацию на большом цветном дисплее с подсветкой, что упрощает эксплуатацию сушилки.",
        //     "wheatpercents": {min:0,max:0},
        //     "wheateff": {min:0,max:0},
        //     "rapepercents": {min:0,max:0},
        //     "rapeeff": {min:0,max:0},
        //     "soypercents": {min:0,max:0},
        //     "soyeff": {min:0,max:0},
        //     "sunflowerpercents": {min:0,max:0},
        //     "sunflowereff": {min:0,max:0},
        //     "cornpercents": {min:2,max:19},
        //     "corneff": {min:198,max:50},
        //     "quantity": 0
        // }
    ],
    "storageEquip": [
      {
        "name": "BEHLEN 5000",
        "price": "315.000",
        "picture": storage,
        "definition": " ",
        "capacity": "5000",
        "quantity": 1
      },
      {
        "name": "BEHLEN 3000",
        "price": "200.000",
        "picture": storage,
        "definition": " ",
        "capacity": "3000",
        "quantity": 0
      },
        {
            "name": "Хопер",
            "price": "40.000",
            "picture": hopper,
            "definition": "",
            "capacity": "500",
            "type": "truck",
            "quantity": 1
        }
    ],
    "outputEquip": [
        // {
        //     "name": "Авто отгрузка",
        //     "price": "240.000",
        //     "picture": truckOutput,
        //     "definition": "",
        //     "capacity": "175",
        //     "type": "truck",
        //     "quantity": 0
        // },
        {
            "name": "ЗД відгрузка",
            "price": "365.000",
            "picture": trainOutput,
            "definition": "",
            "capacity": "175",
            "type": "train",
            "quantity": 1
        }
    ]
};

export default equipSettings;


// WEBPACK FOOTER //
// ./src/shared/stores/presets/equipSettings.js